<form #vacuForm="ngForm" class="w-full sm:w-[55vh]">

    <div class="popup-anim w-full" [ngClass]="{'hidden': showTermsCancelScreen || showDeleteScreen, 'block': !showTermsCancelScreen && !showDeleteScreen}">
      <div class="flex flex-col sm:gap-2">
  
        <!--            NAME-->
        <div class="flex flex-col gap-1">
          <mat-label>{{"Name of service" | translate}}</mat-label>
          <mat-form-field appearance="outline" floatLabel="never">
            <mat-icon matPrefix><i class="fa-regular fa-spa  text-[2rem] pr-[1rem]"></i></mat-icon>
            <input matInput pattern="[a-zA-Zа-яА-ЯѓЃќЌјЈџЏѕЅжЖљЈчЧњЌЌѝЍ() ]*" type="text"
                   [(ngModel)]="serviceData!.name" minlength="3" name="name"
                   placeholder='{{"Name of service" | translate}}' #name="ngModel" required>
            <mat-error *ngIf="name && name.errors">
              <span *ngIf="name.errors['required']">{{"Required Field" | translate}}</span>
              <span *ngIf="name.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
              <span *ngIf="name.errors['pattern']">{{"Allowed only letters" | translate}}</span>
            </mat-error>
          </mat-form-field>
  
        </div>
  
        <!--            PRICE-->
        <div class="flex flex-col gap-1">
          <mat-label>{{"price" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix><i class="fa-regular fa-sack-dollar text-[2rem] pr-[1rem]"></i></mat-icon>
            <input matInput type="number" [(ngModel)]="serviceData!.price" min="0" name="price"
                   placeholder='{{"Price of service" | translate}}'
                   #price="ngModel" required>
            <span matSuffix style="vertical-align: super;">денари </span>
            <mat-error *ngIf="price && price.errors">
              <span *ngIf="price.errors['required']">{{"Required Field" | translate}}</span>
              <span *ngIf="price.errors['min']">{{"Invalid input" | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>
  
        <!--            SERVICE CATEGORY-->
        <div class="flex flex-col gap-1">
          <mat-label>{{'category' | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix><i class="fa-regular fa-layer-group text-[2rem] pr-[1rem]"></i></mat-icon>
            <mat-select [ngModel] [(value)]="serviceData!.serviceCategoryId" name="serviceCategory"
                        #serviceCategory="ngModel" placeholder='{{"category" | translate}}' required>
              <mat-option *ngFor="let serviceCategory of serviceCategoryData" [hidden]="true"
                          [value]="serviceCategory.id">
                {{ serviceCategory.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="serviceCategory && serviceCategory.errors">
                                <span *ngIf="serviceCategory.errors['required']">{{"Required Field" |
                                  translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>
  
        <!--            DURATION-->
        <div class="flex flex-col gap-1">
          <mat-label>{{"duration" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix><i class="fa-regular fa-clock-three text-[2rem] pr-[1rem]"></i></mat-icon>
            <input matInput type="number" [(ngModel)]="serviceData!.duration" min="1" name="duration"
                   class="text-xs sm:text-sm"
                   placeholder='{{"Duration of service" | translate}}'
                   #duration="ngModel" required>
  
            <span matSuffix style="vertical-align: super;">{{"minutes" | translate}}</span>
            <mat-error *ngIf="duration && duration.errors">
              <span *ngIf="duration.errors['required']">{{"Required Field" | translate}}</span>
              <span *ngIf="duration.errors['min']">{{"Invalid input" | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>
  
        <!--            DESCRIPTION-->
        <div class="flex flex-col gap-1">
          <mat-label>{{ "description" | translate }}</mat-label>
          <mat-form-field appearance="outline" style="width: 100%;">
            <div style="display: flex; align-items: flex-start;">
              <mat-icon matPrefix><i class="far fa-file text-[2rem] pr-[1rem]"></i></mat-icon>
              <textarea class="max-h-[8rem] min-h-[1.5rem]" matInput type="text" rows="5" [(ngModel)]="serviceData!.description" minlength="3"
                        name="description"
                        placeholder='{{ "Briefly describe the service" | translate }}'
                        (input)="onChange($event)"></textarea>
            </div>
          </mat-form-field>
        </div>
  
        <!--        ERROR-->
        <div *ngIf="showError"
             class="w-full py-3 px-5 flex flex-row gap-3 bg-[#F5D3D3] text-[#D94E4E] rounded-lg items-center mt-4">
          <i class="fa-sharp fa-regular fa-triangle-exclamation text-3xl"></i>
          <div>{{"service exists" | translate }} "{{name.value}}"</div>
        </div>
  
        <!--  ACTIVE-->
        <div *ngIf="editMode"
        class="flex flex-row gap-5 justify-between items-center w-full py-2 border border-r-transparent border-l-transparent border-t-transparent border-bottom-[#2C99B1] mb-[2rem]">
          <div>{{'service-status' | translate}}:</div>
          <mat-checkbox class="-mb-1 font-semibold text-end" (change)="serviceData !== undefined ? serviceData!.active = !serviceData!.active : null" [checked]="serviceData!.active">
            <div class="pl-[0.5rem] mt-[-.5rem]">
              <div class="opacity-0 h-0" [ngClass]="{'opacity-100 h-auto': serviceData!.active === true}"> {{'service-active' | translate}} </div>
              <div class="opacity-0 h-0" [ngClass]="{'opacity-100 h-auto': serviceData!.active === false}"> {{'service-inactive' | translate}} </div>
            </div>
          </mat-checkbox>
        </div>
  
      </div>
  
      <button 
      *ngIf="editMode"
      (click)="showDeleteScreen = true; negatedTermsToCancel = undefined; $event.preventDefault()" 
      class="mb-[.25rem] w-full bg-[#f44336] hover:bg-[#e93e32] text-[1rem] sm:text-[1.35rem] uppercase active:scale-[0.985] shadow-md active:shadow-sm px-5 py-[.5rem] rounded-[.25rem] text-white">
        {{"Delete service" | translate }}
      </button>

      <!--            ACTION BUTTONS-->
      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]" [ngClass]="{'mt-[1rem]': showError, 'mt-[2rem]': !showError}">
        <button (click)="closePopup(); $event.preventDefault()"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] uppercase bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
          {{"back" | translate}}
        </button>
  
        <button [disabled]="vacuForm.invalid" [ngClass]="{
              'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': vacuForm.valid,
              'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': vacuForm.invalid
            }" (click)="(editMode && serviceData!.active === false && (originalStatus === undefined || serviceData!.active !== originalStatus) ? checkForNegatedTerms() : submit()); $event.preventDefault()" 
            class="w-1/2 uppercase px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md">
          {{"save" | translate}}
        </button>
      </div>

    </div>

    <!-- Warning Message -->
    <div class="popup-anim flex flex-col justify-center gap-[1rem] items-center align-middle md:max-w-[50rem]"
    [ngClass]="{'hidden': !showTermsCancelScreen || showDeleteScreen, 'block': showTermsCancelScreen && !showDeleteScreen}">
      <div class="questionmark_icon w-[8rem] h-[8rem] self-center mt-[-1rem]"> </div>
    
      <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E] w-full">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
              <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
            </svg>
          </div>
          <div class="text-[1.25rem] w-full"> {{"if make service changes terms will be cancelled" | translate }} </div>
      </div>
    
      <div class="p-[1.5rem] border-2 border-[#B98D78] w-full h-full rounded-lg flex flex-col gap-5 overflow-auto max-h-[30rem] text-black">
          <div *ngFor="let term of negatedTermsToCancel" class="flex flex-col gap-2 bg-[#f7f7f8] p-3 shadow-sm rounded-md">
            <div class="flex flex-row gap-1">
              <div class="uppercase text-[1.5rem] font-bold text-black">{{ term.serviceName }}</div>
              <div> {{"-"}} {{ term.fromDate | date : 'dd.MM.yyyy' }} {{"|"}} {{ term.fromDate | date : 'HH:mm' }} - {{ term.toDate | date : 'HH:mm' }}</div>
            </div>
    
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-1 text-[#B98D78]">
                <div class="text-[#767474]"> {{"client" | translate }} </div>
                <div> {{ term.name }} {{ term.surname }} </div>
              </div>
    
              <div class="flex flex-row gap-1">
                <div class="text-[#767474]"> {{"employee" | translate }} </div>
                <div class="italic"> {{ term.employeeName }} {{ term.employeeSurname }} </div>
              </div>
            </div>
    
          </div>
      </div>
    
      <button (click)="submitWithTermsCancel(); $event.preventDefault()" 
      class="my-[.75rem] w-full bg-[#f44336] hover:bg-[#e93e32] text-[1rem] sm:text-[1.35rem] active:scale-[0.985] uppercase shadow-md active:shadow-sm px-5 py-[.5rem] rounded-[.25rem] text-white">
        {{"Save changes and cancel terms" | translate }}
      </button>

      <div class="flex flex-row gap-10 w-full">
        <button (click)="showTermsCancelScreen = false; $event.preventDefault()"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] hover:bg-[#c4c4c4] uppercase active:scale-[0.985] shadow-md active:shadow-sm text-[#696767]">
          {{ "BACK" | translate }}
        </button>
    
        <button (click)="submit(); $event.preventDefault()" class="bg-[#2c99b1] uppercase hover:bg-[#378da0] active:scale-[0.985] shadow-md active:shadow-sm w-1/2 px-5 py-[.5rem] rounded-[.25rem] text-white">
          {{"Save changes" | translate }}
        </button>
      </div>
    </div>

    <!-- Delete Message -->
    <div class="box width_100_percent"
    [ngClass]="{'hidden': !showDeleteScreen || showTermsCancelScreen, 'block': showDeleteScreen && !showTermsCancelScreen}">
      <div class="popup-anim" *ngIf="editMode && showDeleteScreen && (negatedTermsToCancel === undefined || negatedTermsToCancel?.length! <= 0)">
        <div>
          <div class="flex flex-col gap-5">
            <div class="flex flex-col center gap-1">
              <lord-icon src="https://cdn.lordicon.com/drxwpfop.json" trigger="hover"
                colors="primary:#b4b4b4,secondary:#b98d78" style="width:150px;height:150px">
              </lord-icon>
            </div>
    
            <div class="flex flex-col center gap-1 padding_20 text-center">
              <mat-label>{{"services-delete-message" | translate}}</mat-label>
            </div>
          </div>
        </div>
      </div>
  
      <div class="flex flex-col justify-center gap-[1rem] items-center align-middle md:max-w-[50rem] popup-anim" 
      *ngIf="negatedTermsToCancel !== undefined && negatedTermsToCancel.length > 0">
        <div class="questionmark_icon w-[8rem] h-[8rem] self-center mt-[-1rem]"> </div>
        <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E] w-full">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
              <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
            </svg>
          </div>
          <div class="text-[1.25rem] w-full"> {{"if make service changes terms will be cancelled" | translate }} </div>
        </div>
    
        <div class="p-[1.5rem] border-2 border-[#B98D78] w-full h-full rounded-lg flex flex-col gap-5 overflow-auto max-h-[30rem] text-black">
          <div *ngFor="let term of negatedTermsToCancel" class="flex flex-col gap-2 bg-[#f7f7f8] p-3 shadow-sm rounded-md">
            <div class="flex flex-row gap-1">
              <div class="uppercase text-[1.5rem] font-bold text-black">{{ term.serviceName }}</div>
              <div> {{"-"}} {{ term.fromDate | date : 'dd.MM.yyyy' }} {{"|"}} {{ term.fromDate | date : 'HH:mm' }} - {{ term.toDate | date : 'HH:mm' }}</div>
            </div>
    
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-1 text-[#B98D78]">
                <div class="text-[#767474]"> {{"client" | translate }} </div>
                <div> {{ term.name }} {{ term.surname }} </div>
              </div>
    
              <div class="flex flex-row gap-1">
                <div class="text-[#767474]"> {{"employee" | translate }} </div>
                <div class="italic"> {{ term.employeeName }} {{ term.employeeSurname }} </div>
              </div>
            </div>
    
          </div>
        </div>
      </div>
  
      <button *ngIf="negatedTermsToCancel !== undefined && negatedTermsToCancel.length > 0" 
        (click)="deleteWithTermsCancel(); $event.preventDefault()" 
      class="popup-anim mt-[1.5rem] mb-[-.25rem] w-full bg-[#f44336] hover:bg-[#e93e32] text-[1rem] sm:text-[1.35rem] active:scale-[0.985] uppercase shadow-md active:shadow-sm px-5 py-[.5rem] rounded-[.25rem] text-white">
        {{"Delete service and cancel terms" | translate }}
      </button>

      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-[2rem]">
        <button (click)="showDeleteScreen = false; $event.preventDefault()"
          class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] hover:bg-[#c4c4c4] active:scale-[0.985] active:shadow-sm">
          {{'back' | translate}}
        </button>
  
        <button (click)="negatedTermsToCancel === undefined ? checkForNegatedTerms(true) : deleteService()"
          class="w-1/2 bg-[#b98d78] hover:bg-[#a57d6a] px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
          {{'Delete service' | translate}}
        </button>
      </div>
    </div>

</form>

